import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";
import { BooleanInput } from "../inputs";

const DrugTestCategoryForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Field kind="group">
      <Control expanded>
        <Label>Test Code</Label>
        <Input
          required
          autocomplete="new"
          name="TestCode"
          type="text"
          value={inputs.TestCode}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Description</Label>
        <Input
          autocomplete="new"
          name="Description"
          type="text"
          value={inputs.Description}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Drug Test</Label>
        <BooleanInput
          name="DrugTest"
          value={inputs.DrugTest}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Alcohol Test</Label>
        <BooleanInput
          name="AlcoholTest"
          value={inputs.AlcoholTest}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Status</Label>
        <BooleanInput name="Status" value={inputs.Status} onChange={onChange} />
      </Control>
    </Field>
  </React.Fragment>
);

DrugTestCategoryForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
DrugTestCategoryForm.defaultProps = {
  inputs: {}
};
export default DrugTestCategoryForm;
